import React from 'react';
import { Table } from 'react-bootstrap';
import Deal from './Deal';

export default function PresellDealTable(props) {
    const getDealHiddenState = id => !!props.hiddenDeals[id] && props.hiddenDeals[id];
    const highlightedCount = !!props.highlightedProducts
        ? Object.values(props.highlightedProducts).filter(v => v).length
        : 0;

    return (
        <div className={'content'}>
            <Table id="presell-deal-table">
                <thead>
                    <tr>
                        <th>
                            <table className={'presell-deal-table-header'}>
                                <thead>
                                    <th>
                                        <p>&nbsp;</p>
                                        <h3>Deals</h3>
                                    </th>
                                    <th style={{ textAlign: 'right' }}>
                                        <p
                                            style={{ fontSize: '0.8em' }}
                                            data-testid={'presell-filter-result-count-message'}
                                        >
                                            &nbsp;
                                            {!!props.highlightedProducts
                                                ? highlightedCount + ' matching products'
                                                : ''}
                                        </p>
                                        <span>Filter Products:&nbsp;</span>
                                        <input
                                            data-testid={'presell-deal-table-filter'}
                                            style={{ width: '25em' }}
                                            placeholder={'code / description / sequence number'}
                                            type={'text'}
                                            onChange={e => props.setFilterTerm(e.target.value)}
                                        />
                                    </th>
                                </thead>
                            </table>
                        </th>
                    </tr>
                </thead>
                <tbody className={'presell-deal-table-child'}>
                    {props.presell.deals.map(
                        (deal, index) =>
                            !getDealHiddenState(deal.id) && (
                                <Deal
                                    deal={deal}
                                    key={deal.id}
                                    expandedDeals={props.expandedDeals}
                                    setExpandedState={props.setExpandedState}
                                    isOpen={props.expandedDeals[deal.id]}
                                    updateQuantities={props.updateQuantities}
                                    orderingTimeFinished={props.orderingTimeFinished}
                                    highlightedProducts={props.highlightedProducts}
                                />
                            )
                    )}
                </tbody>
            </Table>
        </div>
    );
}
